/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AddTargetNoteMessage } from '../fn/staff/add-target-note-message';
import { AddTargetNoteMessage$Params } from '../fn/staff/add-target-note-message';
import { BehaviorBipInfoModel } from '../models/behavior-bip-info-model';
import { BehaviorBipInfoScreenDataModel } from '../models/behavior-bip-info-screen-data-model';
import { BehaviorFunctionModel } from '../models/behavior-function-model';
import { BipModel } from '../models/bip-model';
import { ChangeProgramNotes } from '../fn/staff/change-program-notes';
import { ChangeProgramNotes$Params } from '../fn/staff/change-program-notes';
import { ChangeTargetNotes } from '../fn/staff/change-target-notes';
import { ChangeTargetNotes$Params } from '../fn/staff/change-target-notes';
import { CreateGroupSession } from '../fn/staff/create-group-session';
import { CreateGroupSession$Params } from '../fn/staff/create-group-session';
import { DataTakerStaffDataModel } from '../models/data-taker-staff-data-model';
import { DeleteAntecedentFromBehaviorBIPInfo } from '../fn/staff/delete-antecedent-from-behavior-bip-info';
import { DeleteAntecedentFromBehaviorBIPInfo$Params } from '../fn/staff/delete-antecedent-from-behavior-bip-info';
import { DeleteConsequenceFromBehaviorBIPInfo } from '../fn/staff/delete-consequence-from-behavior-bip-info';
import { DeleteConsequenceFromBehaviorBIPInfo$Params } from '../fn/staff/delete-consequence-from-behavior-bip-info';
import { DeleteReplacementFromBehaviorBIPInfo } from '../fn/staff/delete-replacement-from-behavior-bip-info';
import { DeleteReplacementFromBehaviorBIPInfo$Params } from '../fn/staff/delete-replacement-from-behavior-bip-info';
import { DownloadGuardianSignature } from '../fn/staff/download-guardian-signature';
import { DownloadGuardianSignature$Params } from '../fn/staff/download-guardian-signature';
import { DownloadStaffHandoffSignature } from '../fn/staff/download-staff-handoff-signature';
import { DownloadStaffHandoffSignature$Params } from '../fn/staff/download-staff-handoff-signature';
import { FinishAndSignBIP } from '../fn/staff/finish-and-sign-bip';
import { FinishAndSignBIP$Params } from '../fn/staff/finish-and-sign-bip';
import { GetActiveStaffMembers } from '../fn/staff/get-active-staff-members';
import { GetActiveStaffMembers$Params } from '../fn/staff/get-active-staff-members';
import { GetAntecedentStrategyTemplates } from '../fn/staff/get-antecedent-strategy-templates';
import { GetAntecedentStrategyTemplates$Params } from '../fn/staff/get-antecedent-strategy-templates';
import { GetBehaviorBipInfoScreenData } from '../fn/staff/get-behavior-bip-info-screen-data';
import { GetBehaviorBipInfoScreenData$Params } from '../fn/staff/get-behavior-bip-info-screen-data';
import { GetBehaviorFunctions } from '../fn/staff/get-behavior-functions';
import { GetBehaviorFunctions$Params } from '../fn/staff/get-behavior-functions';
import { GetBipPdf } from '../fn/staff/get-bip-pdf';
import { GetBipPdf$Params } from '../fn/staff/get-bip-pdf';
import { GetConsequenceStrategyTemplates } from '../fn/staff/get-consequence-strategy-templates';
import { GetConsequenceStrategyTemplates$Params } from '../fn/staff/get-consequence-strategy-templates';
import { GetCurrentBehaviorBIPInfoByBehavior } from '../fn/staff/get-current-behavior-bip-info-by-behavior';
import { GetCurrentBehaviorBIPInfoByBehavior$Params } from '../fn/staff/get-current-behavior-bip-info-by-behavior';
import { GetCurrentBehaviorBIPInfos } from '../fn/staff/get-current-behavior-bip-infos';
import { GetCurrentBehaviorBIPInfos$Params } from '../fn/staff/get-current-behavior-bip-infos';
import { GetCurrentPatientBIPInfo } from '../fn/staff/get-current-patient-bip-info';
import { GetCurrentPatientBIPInfo$Params } from '../fn/staff/get-current-patient-bip-info';
import { GetGroupSession } from '../fn/staff/get-group-session';
import { GetGroupSession$Params } from '../fn/staff/get-group-session';
import { GetListPatientSessions } from '../fn/staff/get-list-patient-sessions';
import { GetListPatientSessions$Params } from '../fn/staff/get-list-patient-sessions';
import { GetMyPatients } from '../fn/staff/get-my-patients';
import { GetMyPatients$Params } from '../fn/staff/get-my-patients';
import { GetMyServices } from '../fn/staff/get-my-services';
import { GetMyServices$Params } from '../fn/staff/get-my-services';
import { GetNewBehaviorBIPInfoByBehavior } from '../fn/staff/get-new-behavior-bip-info-by-behavior';
import { GetNewBehaviorBIPInfoByBehavior$Params } from '../fn/staff/get-new-behavior-bip-info-by-behavior';
import { GetNewBehaviorBIPInfos } from '../fn/staff/get-new-behavior-bip-infos';
import { GetNewBehaviorBIPInfos$Params } from '../fn/staff/get-new-behavior-bip-infos';
import { GetNewPatientBIPInfo } from '../fn/staff/get-new-patient-bip-info';
import { GetNewPatientBIPInfo$Params } from '../fn/staff/get-new-patient-bip-info';
import { GetPatienSession } from '../fn/staff/get-patien-session';
import { GetPatienSession$Params } from '../fn/staff/get-patien-session';
import { GetPatientBehaviorAntecedents } from '../fn/staff/get-patient-behavior-antecedents';
import { GetPatientBehaviorAntecedents$Params } from '../fn/staff/get-patient-behavior-antecedents';
import { GetPatientBehaviorConsequences } from '../fn/staff/get-patient-behavior-consequences';
import { GetPatientBehaviorConsequences$Params } from '../fn/staff/get-patient-behavior-consequences';
import { GetPatientBehaviorData } from '../fn/staff/get-patient-behavior-data';
import { GetPatientBehaviorData$Params } from '../fn/staff/get-patient-behavior-data';
import { GetPatientBehaviorLocations } from '../fn/staff/get-patient-behavior-locations';
import { GetPatientBehaviorLocations$Params } from '../fn/staff/get-patient-behavior-locations';
import { GetPatientBehaviorReplacements } from '../fn/staff/get-patient-behavior-replacements';
import { GetPatientBehaviorReplacements$Params } from '../fn/staff/get-patient-behavior-replacements';
import { GetPatientBehaviorResponses } from '../fn/staff/get-patient-behavior-responses';
import { GetPatientBehaviorResponses$Params } from '../fn/staff/get-patient-behavior-responses';
import { GetPatientBehaviors } from '../fn/staff/get-patient-behaviors';
import { GetPatientBehaviors$Params } from '../fn/staff/get-patient-behaviors';
import { GetPatientBehaviorSeverities } from '../fn/staff/get-patient-behavior-severities';
import { GetPatientBehaviorSeverities$Params } from '../fn/staff/get-patient-behavior-severities';
import { GetPatientBIPs } from '../fn/staff/get-patient-bi-ps';
import { GetPatientBIPs$Params } from '../fn/staff/get-patient-bi-ps';
import { GetPatientGuardians } from '../fn/staff/get-patient-guardians';
import { GetPatientGuardians$Params } from '../fn/staff/get-patient-guardians';
import { GetPatientInfo } from '../fn/staff/get-patient-info';
import { GetPatientInfo$Params } from '../fn/staff/get-patient-info';
import { GetPatientServices } from '../fn/staff/get-patient-services';
import { GetPatientServices$Params } from '../fn/staff/get-patient-services';
import { GetPatientSessions } from '../fn/staff/get-patient-sessions';
import { GetPatientSessions$Params } from '../fn/staff/get-patient-sessions';
import { GetPatientSessionSimpleList } from '../fn/staff/get-patient-session-simple-list';
import { GetPatientSessionSimpleList$Params } from '../fn/staff/get-patient-session-simple-list';
import { GetPatientSessionWithData } from '../fn/staff/get-patient-session-with-data';
import { GetPatientSessionWithData$Params } from '../fn/staff/get-patient-session-with-data';
import { GetPatientTargetData } from '../fn/staff/get-patient-target-data';
import { GetPatientTargetData$Params } from '../fn/staff/get-patient-target-data';
import { GetReplacementStrategyTemplates } from '../fn/staff/get-replacement-strategy-templates';
import { GetReplacementStrategyTemplates$Params } from '../fn/staff/get-replacement-strategy-templates';
import { GetSessionProgressNotes } from '../fn/staff/get-session-progress-notes';
import { GetSessionProgressNotes$Params } from '../fn/staff/get-session-progress-notes';
import { GetTargetNoteMessages } from '../fn/staff/get-target-note-messages';
import { GetTargetNoteMessages$Params } from '../fn/staff/get-target-note-messages';
import { GroupSessionModel } from '../models/group-session-model';
import { GuardianModel } from '../models/guardian-model';
import { MarkAntecedentAsDeleted } from '../fn/staff/mark-antecedent-as-deleted';
import { MarkAntecedentAsDeleted$Params } from '../fn/staff/mark-antecedent-as-deleted';
import { MarkBehaviorAsArchived } from '../fn/staff/mark-behavior-as-archived';
import { MarkBehaviorAsArchived$Params } from '../fn/staff/mark-behavior-as-archived';
import { MarkBehaviorAsDeleted } from '../fn/staff/mark-behavior-as-deleted';
import { MarkBehaviorAsDeleted$Params } from '../fn/staff/mark-behavior-as-deleted';
import { MarkBehaviorClosed } from '../fn/staff/mark-behavior-closed';
import { MarkBehaviorClosed$Params } from '../fn/staff/mark-behavior-closed';
import { MarkBehaviorDataAsDeleted } from '../fn/staff/mark-behavior-data-as-deleted';
import { MarkBehaviorDataAsDeleted$Params } from '../fn/staff/mark-behavior-data-as-deleted';
import { MarkBehaviorMastered } from '../fn/staff/mark-behavior-mastered';
import { MarkBehaviorMastered$Params } from '../fn/staff/mark-behavior-mastered';
import { MarkConsequenceAsDeleted } from '../fn/staff/mark-consequence-as-deleted';
import { MarkConsequenceAsDeleted$Params } from '../fn/staff/mark-consequence-as-deleted';
import { MarkMultiplePatientBehaviorsAsDeleted } from '../fn/staff/mark-multiple-patient-behaviors-as-deleted';
import { MarkMultiplePatientBehaviorsAsDeleted$Params } from '../fn/staff/mark-multiple-patient-behaviors-as-deleted';
import { MarkReplacementAsDeleted } from '../fn/staff/mark-replacement-as-deleted';
import { MarkReplacementAsDeleted$Params } from '../fn/staff/mark-replacement-as-deleted';
import { MarkTargetDataAsDeleted } from '../fn/staff/mark-target-data-as-deleted';
import { MarkTargetDataAsDeleted$Params } from '../fn/staff/mark-target-data-as-deleted';
import { MarkTargetNoteMessagesAsReadByStaff } from '../fn/staff/mark-target-note-messages-as-read-by-staff';
import { MarkTargetNoteMessagesAsReadByStaff$Params } from '../fn/staff/mark-target-note-messages-as-read-by-staff';
import { NameDescriptionModel } from '../models/name-description-model';
import { PatientBehaviorAntecedentModel } from '../models/patient-behavior-antecedent-model';
import { PatientBehaviorConsequenceModel } from '../models/patient-behavior-consequence-model';
import { PatientBehaviorDataModel } from '../models/patient-behavior-data-model';
import { PatientBehaviorLocationModel } from '../models/patient-behavior-location-model';
import { PatientBehaviorModel } from '../models/patient-behavior-model';
import { PatientBehaviorReplacementModel } from '../models/patient-behavior-replacement-model';
import { PatientBehaviorResponseModel } from '../models/patient-behavior-response-model';
import { PatientBehaviorSeverityModel } from '../models/patient-behavior-severity-model';
import { PatientBipInfoModel } from '../models/patient-bip-info-model';
import { PatientDataRecordedDateModel } from '../models/patient-data-recorded-date-model';
import { PatientModel } from '../models/patient-model';
import { PatientServiceSparkModel } from '../models/patient-service-spark-model';
import { PatientSessionModel } from '../models/patient-session-model';
import { PatientTargetDataModel } from '../models/patient-target-data-model';
import { RestoreAntecedent } from '../fn/staff/restore-antecedent';
import { RestoreAntecedent$Params } from '../fn/staff/restore-antecedent';
import { RestoreBehavior } from '../fn/staff/restore-behavior';
import { RestoreBehavior$Params } from '../fn/staff/restore-behavior';
import { RestoreBehaviorDataFromDelete } from '../fn/staff/restore-behavior-data-from-delete';
import { RestoreBehaviorDataFromDelete$Params } from '../fn/staff/restore-behavior-data-from-delete';
import { RestoreConsequence } from '../fn/staff/restore-consequence';
import { RestoreConsequence$Params } from '../fn/staff/restore-consequence';
import { RestoreReplacement } from '../fn/staff/restore-replacement';
import { RestoreReplacement$Params } from '../fn/staff/restore-replacement';
import { RestoreTargetDataFromDelete } from '../fn/staff/restore-target-data-from-delete';
import { RestoreTargetDataFromDelete$Params } from '../fn/staff/restore-target-data-from-delete';
import { SaveBehaviorBIPInfo } from '../fn/staff/save-behavior-bip-info';
import { SaveBehaviorBIPInfo$Params } from '../fn/staff/save-behavior-bip-info';
import { SaveBehaviorOrder } from '../fn/staff/save-behavior-order';
import { SaveBehaviorOrder$Params } from '../fn/staff/save-behavior-order';
import { SavePatientBehavior } from '../fn/staff/save-patient-behavior';
import { SavePatientBehavior$Params } from '../fn/staff/save-patient-behavior';
import { SavePatientBehaviorAntecedent } from '../fn/staff/save-patient-behavior-antecedent';
import { SavePatientBehaviorAntecedent$Params } from '../fn/staff/save-patient-behavior-antecedent';
import { SavePatientBehaviorConsequence } from '../fn/staff/save-patient-behavior-consequence';
import { SavePatientBehaviorConsequence$Params } from '../fn/staff/save-patient-behavior-consequence';
import { SavePatientBehaviorData } from '../fn/staff/save-patient-behavior-data';
import { SavePatientBehaviorData$Params } from '../fn/staff/save-patient-behavior-data';
import { SavePatientBehaviorReplacement } from '../fn/staff/save-patient-behavior-replacement';
import { SavePatientBehaviorReplacement$Params } from '../fn/staff/save-patient-behavior-replacement';
import { SavePatientBIPInfo } from '../fn/staff/save-patient-bip-info';
import { SavePatientBIPInfo$Params } from '../fn/staff/save-patient-bip-info';
import { SavePatientSession } from '../fn/staff/save-patient-session';
import { SavePatientSession$Params } from '../fn/staff/save-patient-session';
import { SavePatientTargetData } from '../fn/staff/save-patient-target-data';
import { SavePatientTargetData$Params } from '../fn/staff/save-patient-target-data';
import { SaveSessionProgressNotes } from '../fn/staff/save-session-progress-notes';
import { SaveSessionProgressNotes$Params } from '../fn/staff/save-session-progress-notes';
import { ServiceSparkModel } from '../models/service-spark-model';
import { SessionProgressNoteModel } from '../models/session-progress-note-model';
import { SessionSimpleDataModel } from '../models/session-simple-data-model';
import { TargetNoteMessageModel } from '../models/target-note-message-model';
import { TargetNoteMessagesPageModel } from '../models/target-note-messages-page-model';
import { UpdatePatientDataRecordedDate } from '../fn/staff/update-patient-data-recorded-date';
import { UpdatePatientDataRecordedDate$Params } from '../fn/staff/update-patient-data-recorded-date';
import { UploadGuardianSignature } from '../fn/staff/upload-guardian-signature';
import { UploadGuardianSignature$Params } from '../fn/staff/upload-guardian-signature';
import { UploadStaffHandoffSignature } from '../fn/staff/upload-staff-handoff-signature';
import { UploadStaffHandoffSignature$Params } from '../fn/staff/upload-staff-handoff-signature';

@Injectable({ providedIn: 'root' })
export class StaffApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiStaffCreateGroupSessionPost()` */
  static readonly ApiStaffCreateGroupSessionPostPath = '/api/Staff/CreateGroupSession';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `CreateGroupSession()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  CreateGroupSession$Response(params?: CreateGroupSession$Params, context?: HttpContext): Observable<StrictHttpResponse<GroupSessionModel>> {
    return CreateGroupSession(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `CreateGroupSession$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  CreateGroupSession(params?: CreateGroupSession$Params, context?: HttpContext): Observable<GroupSessionModel> {
    return this.CreateGroupSession$Response(params, context).pipe(
      map((r: StrictHttpResponse<GroupSessionModel>): GroupSessionModel => r.body)
    );
  }

  /** Path part for operation `apiStaffGetGroupSessionGet()` */
  static readonly ApiStaffGetGroupSessionGetPath = '/api/Staff/GetGroupSession';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetGroupSession()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetGroupSession$Response(params?: GetGroupSession$Params, context?: HttpContext): Observable<StrictHttpResponse<GroupSessionModel>> {
    return GetGroupSession(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetGroupSession$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetGroupSession(params?: GetGroupSession$Params, context?: HttpContext): Observable<GroupSessionModel> {
    return this.GetGroupSession$Response(params, context).pipe(
      map((r: StrictHttpResponse<GroupSessionModel>): GroupSessionModel => r.body)
    );
  }

  /** Path part for operation `apiStaffGetMyPatientsGet()` */
  static readonly ApiStaffGetMyPatientsGetPath = '/api/Staff/GetMyPatients';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetMyPatients()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetMyPatients$Response(params?: GetMyPatients$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientModel>>> {
    return GetMyPatients(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetMyPatients$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetMyPatients(params?: GetMyPatients$Params, context?: HttpContext): Observable<Array<PatientModel>> {
    return this.GetMyPatients$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PatientModel>>): Array<PatientModel> => r.body)
    );
  }

  /** Path part for operation `apiStaffGetPatientInfoGet()` */
  static readonly ApiStaffGetPatientInfoGetPath = '/api/Staff/GetPatientInfo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPatientInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientInfo$Response(params?: GetPatientInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientModel>> {
    return GetPatientInfo(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPatientInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientInfo(params?: GetPatientInfo$Params, context?: HttpContext): Observable<PatientModel> {
    return this.GetPatientInfo$Response(params, context).pipe(
      map((r: StrictHttpResponse<PatientModel>): PatientModel => r.body)
    );
  }

  /** Path part for operation `apiStaffGetListPatientSessionsGet()` */
  static readonly ApiStaffGetListPatientSessionsGetPath = '/api/Staff/GetListPatientSessions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetListPatientSessions()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetListPatientSessions$Response(params?: GetListPatientSessions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientSessionModel>>> {
    return GetListPatientSessions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetListPatientSessions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetListPatientSessions(params?: GetListPatientSessions$Params, context?: HttpContext): Observable<Array<PatientSessionModel>> {
    return this.GetListPatientSessions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PatientSessionModel>>): Array<PatientSessionModel> => r.body)
    );
  }

  /** Path part for operation `apiStaffGetPatientSessionWithDataGet()` */
  static readonly ApiStaffGetPatientSessionWithDataGetPath = '/api/Staff/GetPatientSessionWithData';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPatientSessionWithData()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientSessionWithData$Response(params?: GetPatientSessionWithData$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientSessionModel>> {
    return GetPatientSessionWithData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPatientSessionWithData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientSessionWithData(params?: GetPatientSessionWithData$Params, context?: HttpContext): Observable<PatientSessionModel> {
    return this.GetPatientSessionWithData$Response(params, context).pipe(
      map((r: StrictHttpResponse<PatientSessionModel>): PatientSessionModel => r.body)
    );
  }

  /** Path part for operation `apiStaffGetPatientSessionSimpleListGet()` */
  static readonly ApiStaffGetPatientSessionSimpleListGetPath = '/api/Staff/GetPatientSessionSimpleList';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPatientSessionSimpleList()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientSessionSimpleList$Response(params?: GetPatientSessionSimpleList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SessionSimpleDataModel>>> {
    return GetPatientSessionSimpleList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPatientSessionSimpleList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientSessionSimpleList(params?: GetPatientSessionSimpleList$Params, context?: HttpContext): Observable<Array<SessionSimpleDataModel>> {
    return this.GetPatientSessionSimpleList$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SessionSimpleDataModel>>): Array<SessionSimpleDataModel> => r.body)
    );
  }

  /** Path part for operation `apiStaffGetPatientSessionsGet()` */
  static readonly ApiStaffGetPatientSessionsGetPath = '/api/Staff/GetPatientSessions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPatientSessions()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientSessions$Response(params?: GetPatientSessions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientSessionModel>>> {
    return GetPatientSessions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPatientSessions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientSessions(params?: GetPatientSessions$Params, context?: HttpContext): Observable<Array<PatientSessionModel>> {
    return this.GetPatientSessions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PatientSessionModel>>): Array<PatientSessionModel> => r.body)
    );
  }

  /** Path part for operation `apiStaffGetActiveStaffMembersGet()` */
  static readonly ApiStaffGetActiveStaffMembersGetPath = '/api/Staff/GetActiveStaffMembers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetActiveStaffMembers()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetActiveStaffMembers$Response(params?: GetActiveStaffMembers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DataTakerStaffDataModel>>> {
    return GetActiveStaffMembers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetActiveStaffMembers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetActiveStaffMembers(params?: GetActiveStaffMembers$Params, context?: HttpContext): Observable<Array<DataTakerStaffDataModel>> {
    return this.GetActiveStaffMembers$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DataTakerStaffDataModel>>): Array<DataTakerStaffDataModel> => r.body)
    );
  }

  /** Path part for operation `apiStaffGetPatienSessionGet()` */
  static readonly ApiStaffGetPatienSessionGetPath = '/api/Staff/GetPatienSession';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPatienSession()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatienSession$Response(params?: GetPatienSession$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientSessionModel>> {
    return GetPatienSession(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPatienSession$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatienSession(params?: GetPatienSession$Params, context?: HttpContext): Observable<PatientSessionModel> {
    return this.GetPatienSession$Response(params, context).pipe(
      map((r: StrictHttpResponse<PatientSessionModel>): PatientSessionModel => r.body)
    );
  }

  /** Path part for operation `apiStaffSavePatientSessionPost()` */
  static readonly ApiStaffSavePatientSessionPostPath = '/api/Staff/SavePatientSession';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SavePatientSession()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePatientSession$Response(params?: SavePatientSession$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientSessionModel>> {
    return SavePatientSession(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SavePatientSession$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePatientSession(params?: SavePatientSession$Params, context?: HttpContext): Observable<PatientSessionModel> {
    return this.SavePatientSession$Response(params, context).pipe(
      map((r: StrictHttpResponse<PatientSessionModel>): PatientSessionModel => r.body)
    );
  }

  /** Path part for operation `apiStaffGetPatientBehaviorsGet()` */
  static readonly ApiStaffGetPatientBehaviorsGetPath = '/api/Staff/GetPatientBehaviors';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPatientBehaviors()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientBehaviors$Response(params?: GetPatientBehaviors$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientBehaviorModel>>> {
    return GetPatientBehaviors(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPatientBehaviors$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientBehaviors(params?: GetPatientBehaviors$Params, context?: HttpContext): Observable<Array<PatientBehaviorModel>> {
    return this.GetPatientBehaviors$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PatientBehaviorModel>>): Array<PatientBehaviorModel> => r.body)
    );
  }

  /** Path part for operation `apiStaffSavePatientBehaviorPost()` */
  static readonly ApiStaffSavePatientBehaviorPostPath = '/api/Staff/SavePatientBehavior';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SavePatientBehavior()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePatientBehavior$Response(params?: SavePatientBehavior$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientBehaviorModel>> {
    return SavePatientBehavior(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SavePatientBehavior$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePatientBehavior(params?: SavePatientBehavior$Params, context?: HttpContext): Observable<PatientBehaviorModel> {
    return this.SavePatientBehavior$Response(params, context).pipe(
      map((r: StrictHttpResponse<PatientBehaviorModel>): PatientBehaviorModel => r.body)
    );
  }

  /** Path part for operation `apiStaffMarkBehaviorAsDeletedPost()` */
  static readonly ApiStaffMarkBehaviorAsDeletedPostPath = '/api/Staff/MarkBehaviorAsDeleted';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `MarkBehaviorAsDeleted()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkBehaviorAsDeleted$Response(params?: MarkBehaviorAsDeleted$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return MarkBehaviorAsDeleted(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `MarkBehaviorAsDeleted$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkBehaviorAsDeleted(params?: MarkBehaviorAsDeleted$Params, context?: HttpContext): Observable<void> {
    return this.MarkBehaviorAsDeleted$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiStaffMarkBehaviorClosedPost()` */
  static readonly ApiStaffMarkBehaviorClosedPostPath = '/api/Staff/MarkBehaviorClosed';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `MarkBehaviorClosed()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkBehaviorClosed$Response(params?: MarkBehaviorClosed$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return MarkBehaviorClosed(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `MarkBehaviorClosed$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkBehaviorClosed(params?: MarkBehaviorClosed$Params, context?: HttpContext): Observable<void> {
    return this.MarkBehaviorClosed$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiStaffMarkBehaviorMasteredPost()` */
  static readonly ApiStaffMarkBehaviorMasteredPostPath = '/api/Staff/MarkBehaviorMastered';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `MarkBehaviorMastered()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkBehaviorMastered$Response(params?: MarkBehaviorMastered$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return MarkBehaviorMastered(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `MarkBehaviorMastered$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkBehaviorMastered(params?: MarkBehaviorMastered$Params, context?: HttpContext): Observable<void> {
    return this.MarkBehaviorMastered$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiStaffMarkBehaviorAsArchivedPost()` */
  static readonly ApiStaffMarkBehaviorAsArchivedPostPath = '/api/Staff/MarkBehaviorAsArchived';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `MarkBehaviorAsArchived()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkBehaviorAsArchived$Response(params?: MarkBehaviorAsArchived$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return MarkBehaviorAsArchived(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `MarkBehaviorAsArchived$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkBehaviorAsArchived(params?: MarkBehaviorAsArchived$Params, context?: HttpContext): Observable<void> {
    return this.MarkBehaviorAsArchived$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiStaffRestoreBehaviorPost()` */
  static readonly ApiStaffRestoreBehaviorPostPath = '/api/Staff/RestoreBehavior';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `RestoreBehavior()` instead.
   *
   * This method doesn't expect any request body.
   */
  RestoreBehavior$Response(params?: RestoreBehavior$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return RestoreBehavior(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `RestoreBehavior$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  RestoreBehavior(params?: RestoreBehavior$Params, context?: HttpContext): Observable<void> {
    return this.RestoreBehavior$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiStaffMarkBehaviorDataAsDeletedPost()` */
  static readonly ApiStaffMarkBehaviorDataAsDeletedPostPath = '/api/Staff/MarkBehaviorDataAsDeleted';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `MarkBehaviorDataAsDeleted()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkBehaviorDataAsDeleted$Response(params?: MarkBehaviorDataAsDeleted$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return MarkBehaviorDataAsDeleted(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `MarkBehaviorDataAsDeleted$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkBehaviorDataAsDeleted(params?: MarkBehaviorDataAsDeleted$Params, context?: HttpContext): Observable<void> {
    return this.MarkBehaviorDataAsDeleted$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiStaffMarkTargetDataAsDeletedPost()` */
  static readonly ApiStaffMarkTargetDataAsDeletedPostPath = '/api/Staff/MarkTargetDataAsDeleted';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `MarkTargetDataAsDeleted()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkTargetDataAsDeleted$Response(params?: MarkTargetDataAsDeleted$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return MarkTargetDataAsDeleted(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `MarkTargetDataAsDeleted$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkTargetDataAsDeleted(params?: MarkTargetDataAsDeleted$Params, context?: HttpContext): Observable<void> {
    return this.MarkTargetDataAsDeleted$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiStaffRestoreTargetDataFromDeletePost()` */
  static readonly ApiStaffRestoreTargetDataFromDeletePostPath = '/api/Staff/RestoreTargetDataFromDelete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `RestoreTargetDataFromDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  RestoreTargetDataFromDelete$Response(params?: RestoreTargetDataFromDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return RestoreTargetDataFromDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `RestoreTargetDataFromDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  RestoreTargetDataFromDelete(params?: RestoreTargetDataFromDelete$Params, context?: HttpContext): Observable<void> {
    return this.RestoreTargetDataFromDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiStaffRestoreBehaviorDataFromDeletePost()` */
  static readonly ApiStaffRestoreBehaviorDataFromDeletePostPath = '/api/Staff/RestoreBehaviorDataFromDelete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `RestoreBehaviorDataFromDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  RestoreBehaviorDataFromDelete$Response(params?: RestoreBehaviorDataFromDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return RestoreBehaviorDataFromDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `RestoreBehaviorDataFromDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  RestoreBehaviorDataFromDelete(params?: RestoreBehaviorDataFromDelete$Params, context?: HttpContext): Observable<void> {
    return this.RestoreBehaviorDataFromDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiStaffGetPatientTargetDataGet()` */
  static readonly ApiStaffGetPatientTargetDataGetPath = '/api/Staff/GetPatientTargetData';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPatientTargetData()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientTargetData$Response(params?: GetPatientTargetData$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientTargetDataModel>>> {
    return GetPatientTargetData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPatientTargetData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientTargetData(params?: GetPatientTargetData$Params, context?: HttpContext): Observable<Array<PatientTargetDataModel>> {
    return this.GetPatientTargetData$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PatientTargetDataModel>>): Array<PatientTargetDataModel> => r.body)
    );
  }

  /** Path part for operation `apiStaffUpdatePatientDataRecordedDatePost()` */
  static readonly ApiStaffUpdatePatientDataRecordedDatePostPath = '/api/Staff/UpdatePatientDataRecordedDate';

  /**
   * Explicitly corrects one recorded date without allowing ordinary sync to change existing dates.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `UpdatePatientDataRecordedDate()` instead.
   *
   * This method doesn't expect any request body.
   */
  UpdatePatientDataRecordedDate$Response(params?: UpdatePatientDataRecordedDate$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientDataRecordedDateModel>> {
    return UpdatePatientDataRecordedDate(this.http, this.rootUrl, params, context);
  }

  /**
   * Explicitly corrects one recorded date without allowing ordinary sync to change existing dates.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `UpdatePatientDataRecordedDate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  UpdatePatientDataRecordedDate(params?: UpdatePatientDataRecordedDate$Params, context?: HttpContext): Observable<PatientDataRecordedDateModel> {
    return this.UpdatePatientDataRecordedDate$Response(params, context).pipe(
      map((r: StrictHttpResponse<PatientDataRecordedDateModel>): PatientDataRecordedDateModel => r.body)
    );
  }

  /** Path part for operation `apiStaffSavePatientTargetDataPost()` */
  static readonly ApiStaffSavePatientTargetDataPostPath = '/api/Staff/SavePatientTargetData';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SavePatientTargetData()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePatientTargetData$Response(params?: SavePatientTargetData$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientTargetDataModel>> {
    return SavePatientTargetData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SavePatientTargetData$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePatientTargetData(params?: SavePatientTargetData$Params, context?: HttpContext): Observable<PatientTargetDataModel> {
    return this.SavePatientTargetData$Response(params, context).pipe(
      map((r: StrictHttpResponse<PatientTargetDataModel>): PatientTargetDataModel => r.body)
    );
  }

  /** Path part for operation `apiStaffGetPatientBehaviorDataGet()` */
  static readonly ApiStaffGetPatientBehaviorDataGetPath = '/api/Staff/GetPatientBehaviorData';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPatientBehaviorData()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientBehaviorData$Response(params?: GetPatientBehaviorData$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientBehaviorDataModel>>> {
    return GetPatientBehaviorData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPatientBehaviorData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientBehaviorData(params?: GetPatientBehaviorData$Params, context?: HttpContext): Observable<Array<PatientBehaviorDataModel>> {
    return this.GetPatientBehaviorData$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PatientBehaviorDataModel>>): Array<PatientBehaviorDataModel> => r.body)
    );
  }

  /** Path part for operation `apiStaffSavePatientBehaviorDataPost()` */
  static readonly ApiStaffSavePatientBehaviorDataPostPath = '/api/Staff/SavePatientBehaviorData';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SavePatientBehaviorData()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePatientBehaviorData$Response(params?: SavePatientBehaviorData$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientBehaviorDataModel>> {
    return SavePatientBehaviorData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SavePatientBehaviorData$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePatientBehaviorData(params?: SavePatientBehaviorData$Params, context?: HttpContext): Observable<PatientBehaviorDataModel> {
    return this.SavePatientBehaviorData$Response(params, context).pipe(
      map((r: StrictHttpResponse<PatientBehaviorDataModel>): PatientBehaviorDataModel => r.body)
    );
  }

  /** Path part for operation `apiStaffChangeProgramNotesPost()` */
  static readonly ApiStaffChangeProgramNotesPostPath = '/api/Staff/ChangeProgramNotes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ChangeProgramNotes()` instead.
   *
   * This method doesn't expect any request body.
   */
  ChangeProgramNotes$Response(params?: ChangeProgramNotes$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return ChangeProgramNotes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ChangeProgramNotes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ChangeProgramNotes(params?: ChangeProgramNotes$Params, context?: HttpContext): Observable<string> {
    return this.ChangeProgramNotes$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiStaffChangeTargetNotesPost()` */
  static readonly ApiStaffChangeTargetNotesPostPath = '/api/Staff/ChangeTargetNotes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ChangeTargetNotes()` instead.
   *
   * This method doesn't expect any request body.
   */
  ChangeTargetNotes$Response(params?: ChangeTargetNotes$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return ChangeTargetNotes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ChangeTargetNotes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ChangeTargetNotes(params?: ChangeTargetNotes$Params, context?: HttpContext): Observable<string> {
    return this.ChangeTargetNotes$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiStaffGetTargetNoteMessagesGet()` */
  static readonly ApiStaffGetTargetNoteMessagesGetPath = '/api/Staff/GetTargetNoteMessages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetTargetNoteMessages()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetTargetNoteMessages$Response(params?: GetTargetNoteMessages$Params, context?: HttpContext): Observable<StrictHttpResponse<TargetNoteMessagesPageModel>> {
    return GetTargetNoteMessages(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetTargetNoteMessages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetTargetNoteMessages(params?: GetTargetNoteMessages$Params, context?: HttpContext): Observable<TargetNoteMessagesPageModel> {
    return this.GetTargetNoteMessages$Response(params, context).pipe(
      map((r: StrictHttpResponse<TargetNoteMessagesPageModel>): TargetNoteMessagesPageModel => r.body)
    );
  }

  /** Path part for operation `apiStaffAddTargetNoteMessagePost()` */
  static readonly ApiStaffAddTargetNoteMessagePostPath = '/api/Staff/AddTargetNoteMessage';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `AddTargetNoteMessage()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  AddTargetNoteMessage$Response(params?: AddTargetNoteMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<TargetNoteMessageModel>> {
    return AddTargetNoteMessage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `AddTargetNoteMessage$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  AddTargetNoteMessage(params?: AddTargetNoteMessage$Params, context?: HttpContext): Observable<TargetNoteMessageModel> {
    return this.AddTargetNoteMessage$Response(params, context).pipe(
      map((r: StrictHttpResponse<TargetNoteMessageModel>): TargetNoteMessageModel => r.body)
    );
  }

  /** Path part for operation `apiStaffMarkTargetNoteMessagesAsReadByStaffPost()` */
  static readonly ApiStaffMarkTargetNoteMessagesAsReadByStaffPostPath = '/api/Staff/MarkTargetNoteMessagesAsReadByStaff';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `MarkTargetNoteMessagesAsReadByStaff()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkTargetNoteMessagesAsReadByStaff$Response(params?: MarkTargetNoteMessagesAsReadByStaff$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return MarkTargetNoteMessagesAsReadByStaff(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `MarkTargetNoteMessagesAsReadByStaff$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkTargetNoteMessagesAsReadByStaff(params?: MarkTargetNoteMessagesAsReadByStaff$Params, context?: HttpContext): Observable<void> {
    return this.MarkTargetNoteMessagesAsReadByStaff$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiStaffGetPatientGuardiansGet()` */
  static readonly ApiStaffGetPatientGuardiansGetPath = '/api/Staff/GetPatientGuardians';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPatientGuardians()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientGuardians$Response(params?: GetPatientGuardians$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GuardianModel>>> {
    return GetPatientGuardians(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPatientGuardians$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientGuardians(params?: GetPatientGuardians$Params, context?: HttpContext): Observable<Array<GuardianModel>> {
    return this.GetPatientGuardians$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<GuardianModel>>): Array<GuardianModel> => r.body)
    );
  }

  /** Path part for operation `apiStaffGetPatientBehaviorLocationsGet()` */
  static readonly ApiStaffGetPatientBehaviorLocationsGetPath = '/api/Staff/GetPatientBehaviorLocations';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPatientBehaviorLocations()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientBehaviorLocations$Response(params?: GetPatientBehaviorLocations$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientBehaviorLocationModel>>> {
    return GetPatientBehaviorLocations(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPatientBehaviorLocations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientBehaviorLocations(params?: GetPatientBehaviorLocations$Params, context?: HttpContext): Observable<Array<PatientBehaviorLocationModel>> {
    return this.GetPatientBehaviorLocations$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PatientBehaviorLocationModel>>): Array<PatientBehaviorLocationModel> => r.body)
    );
  }

  /** Path part for operation `apiStaffGetPatientBehaviorConsequencesGet()` */
  static readonly ApiStaffGetPatientBehaviorConsequencesGetPath = '/api/Staff/GetPatientBehaviorConsequences';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPatientBehaviorConsequences()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientBehaviorConsequences$Response(params?: GetPatientBehaviorConsequences$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientBehaviorConsequenceModel>>> {
    return GetPatientBehaviorConsequences(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPatientBehaviorConsequences$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientBehaviorConsequences(params?: GetPatientBehaviorConsequences$Params, context?: HttpContext): Observable<Array<PatientBehaviorConsequenceModel>> {
    return this.GetPatientBehaviorConsequences$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PatientBehaviorConsequenceModel>>): Array<PatientBehaviorConsequenceModel> => r.body)
    );
  }

  /** Path part for operation `apiStaffGetPatientBehaviorResponsesGet()` */
  static readonly ApiStaffGetPatientBehaviorResponsesGetPath = '/api/Staff/GetPatientBehaviorResponses';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPatientBehaviorResponses()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientBehaviorResponses$Response(params?: GetPatientBehaviorResponses$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientBehaviorResponseModel>>> {
    return GetPatientBehaviorResponses(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPatientBehaviorResponses$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientBehaviorResponses(params?: GetPatientBehaviorResponses$Params, context?: HttpContext): Observable<Array<PatientBehaviorResponseModel>> {
    return this.GetPatientBehaviorResponses$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PatientBehaviorResponseModel>>): Array<PatientBehaviorResponseModel> => r.body)
    );
  }

  /** Path part for operation `apiStaffGetPatientBehaviorSeveritiesGet()` */
  static readonly ApiStaffGetPatientBehaviorSeveritiesGetPath = '/api/Staff/GetPatientBehaviorSeverities';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPatientBehaviorSeverities()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientBehaviorSeverities$Response(params?: GetPatientBehaviorSeverities$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientBehaviorSeverityModel>>> {
    return GetPatientBehaviorSeverities(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPatientBehaviorSeverities$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientBehaviorSeverities(params?: GetPatientBehaviorSeverities$Params, context?: HttpContext): Observable<Array<PatientBehaviorSeverityModel>> {
    return this.GetPatientBehaviorSeverities$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PatientBehaviorSeverityModel>>): Array<PatientBehaviorSeverityModel> => r.body)
    );
  }

  /** Path part for operation `apiStaffGetPatientBehaviorAntecedentsGet()` */
  static readonly ApiStaffGetPatientBehaviorAntecedentsGetPath = '/api/Staff/GetPatientBehaviorAntecedents';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPatientBehaviorAntecedents()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientBehaviorAntecedents$Response(params?: GetPatientBehaviorAntecedents$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientBehaviorAntecedentModel>>> {
    return GetPatientBehaviorAntecedents(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPatientBehaviorAntecedents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientBehaviorAntecedents(params?: GetPatientBehaviorAntecedents$Params, context?: HttpContext): Observable<Array<PatientBehaviorAntecedentModel>> {
    return this.GetPatientBehaviorAntecedents$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PatientBehaviorAntecedentModel>>): Array<PatientBehaviorAntecedentModel> => r.body)
    );
  }

  /** Path part for operation `apiStaffSavePatientBehaviorAntecedentPost()` */
  static readonly ApiStaffSavePatientBehaviorAntecedentPostPath = '/api/Staff/SavePatientBehaviorAntecedent';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SavePatientBehaviorAntecedent()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePatientBehaviorAntecedent$Response(params?: SavePatientBehaviorAntecedent$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientBehaviorAntecedentModel>> {
    return SavePatientBehaviorAntecedent(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SavePatientBehaviorAntecedent$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePatientBehaviorAntecedent(params?: SavePatientBehaviorAntecedent$Params, context?: HttpContext): Observable<PatientBehaviorAntecedentModel> {
    return this.SavePatientBehaviorAntecedent$Response(params, context).pipe(
      map((r: StrictHttpResponse<PatientBehaviorAntecedentModel>): PatientBehaviorAntecedentModel => r.body)
    );
  }

  /** Path part for operation `apiStaffSavePatientBehaviorConsequencePost()` */
  static readonly ApiStaffSavePatientBehaviorConsequencePostPath = '/api/Staff/SavePatientBehaviorConsequence';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SavePatientBehaviorConsequence()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePatientBehaviorConsequence$Response(params?: SavePatientBehaviorConsequence$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientBehaviorConsequenceModel>> {
    return SavePatientBehaviorConsequence(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SavePatientBehaviorConsequence$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePatientBehaviorConsequence(params?: SavePatientBehaviorConsequence$Params, context?: HttpContext): Observable<PatientBehaviorConsequenceModel> {
    return this.SavePatientBehaviorConsequence$Response(params, context).pipe(
      map((r: StrictHttpResponse<PatientBehaviorConsequenceModel>): PatientBehaviorConsequenceModel => r.body)
    );
  }

  /** Path part for operation `apiStaffMarkAntecedentAsDeletedPost()` */
  static readonly ApiStaffMarkAntecedentAsDeletedPostPath = '/api/Staff/MarkAntecedentAsDeleted';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `MarkAntecedentAsDeleted()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkAntecedentAsDeleted$Response(params?: MarkAntecedentAsDeleted$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return MarkAntecedentAsDeleted(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `MarkAntecedentAsDeleted$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkAntecedentAsDeleted(params?: MarkAntecedentAsDeleted$Params, context?: HttpContext): Observable<void> {
    return this.MarkAntecedentAsDeleted$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiStaffRestoreAntecedentPost()` */
  static readonly ApiStaffRestoreAntecedentPostPath = '/api/Staff/RestoreAntecedent';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `RestoreAntecedent()` instead.
   *
   * This method doesn't expect any request body.
   */
  RestoreAntecedent$Response(params?: RestoreAntecedent$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return RestoreAntecedent(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `RestoreAntecedent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  RestoreAntecedent(params?: RestoreAntecedent$Params, context?: HttpContext): Observable<void> {
    return this.RestoreAntecedent$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiStaffMarkConsequenceAsDeletedPost()` */
  static readonly ApiStaffMarkConsequenceAsDeletedPostPath = '/api/Staff/MarkConsequenceAsDeleted';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `MarkConsequenceAsDeleted()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkConsequenceAsDeleted$Response(params?: MarkConsequenceAsDeleted$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return MarkConsequenceAsDeleted(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `MarkConsequenceAsDeleted$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkConsequenceAsDeleted(params?: MarkConsequenceAsDeleted$Params, context?: HttpContext): Observable<void> {
    return this.MarkConsequenceAsDeleted$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiStaffRestoreConsequencePost()` */
  static readonly ApiStaffRestoreConsequencePostPath = '/api/Staff/RestoreConsequence';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `RestoreConsequence()` instead.
   *
   * This method doesn't expect any request body.
   */
  RestoreConsequence$Response(params?: RestoreConsequence$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return RestoreConsequence(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `RestoreConsequence$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  RestoreConsequence(params?: RestoreConsequence$Params, context?: HttpContext): Observable<void> {
    return this.RestoreConsequence$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiStaffGetPatientBehaviorReplacementsGet()` */
  static readonly ApiStaffGetPatientBehaviorReplacementsGetPath = '/api/Staff/GetPatientBehaviorReplacements';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPatientBehaviorReplacements()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientBehaviorReplacements$Response(params?: GetPatientBehaviorReplacements$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientBehaviorReplacementModel>>> {
    return GetPatientBehaviorReplacements(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPatientBehaviorReplacements$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientBehaviorReplacements(params?: GetPatientBehaviorReplacements$Params, context?: HttpContext): Observable<Array<PatientBehaviorReplacementModel>> {
    return this.GetPatientBehaviorReplacements$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PatientBehaviorReplacementModel>>): Array<PatientBehaviorReplacementModel> => r.body)
    );
  }

  /** Path part for operation `apiStaffSavePatientBehaviorReplacementPost()` */
  static readonly ApiStaffSavePatientBehaviorReplacementPostPath = '/api/Staff/SavePatientBehaviorReplacement';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SavePatientBehaviorReplacement()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePatientBehaviorReplacement$Response(params?: SavePatientBehaviorReplacement$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientBehaviorReplacementModel>> {
    return SavePatientBehaviorReplacement(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SavePatientBehaviorReplacement$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePatientBehaviorReplacement(params?: SavePatientBehaviorReplacement$Params, context?: HttpContext): Observable<PatientBehaviorReplacementModel> {
    return this.SavePatientBehaviorReplacement$Response(params, context).pipe(
      map((r: StrictHttpResponse<PatientBehaviorReplacementModel>): PatientBehaviorReplacementModel => r.body)
    );
  }

  /** Path part for operation `apiStaffMarkReplacementAsDeletedPost()` */
  static readonly ApiStaffMarkReplacementAsDeletedPostPath = '/api/Staff/MarkReplacementAsDeleted';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `MarkReplacementAsDeleted()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkReplacementAsDeleted$Response(params?: MarkReplacementAsDeleted$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return MarkReplacementAsDeleted(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `MarkReplacementAsDeleted$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkReplacementAsDeleted(params?: MarkReplacementAsDeleted$Params, context?: HttpContext): Observable<void> {
    return this.MarkReplacementAsDeleted$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiStaffRestoreReplacementPost()` */
  static readonly ApiStaffRestoreReplacementPostPath = '/api/Staff/RestoreReplacement';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `RestoreReplacement()` instead.
   *
   * This method doesn't expect any request body.
   */
  RestoreReplacement$Response(params?: RestoreReplacement$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return RestoreReplacement(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `RestoreReplacement$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  RestoreReplacement(params?: RestoreReplacement$Params, context?: HttpContext): Observable<void> {
    return this.RestoreReplacement$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiStaffGetCurrentBehaviorBipInfosGet()` */
  static readonly ApiStaffGetCurrentBehaviorBipInfosGetPath = '/api/Staff/GetCurrentBehaviorBIPInfos';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetCurrentBehaviorBIPInfos()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetCurrentBehaviorBIPInfos$Response(params?: GetCurrentBehaviorBIPInfos$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BehaviorBipInfoModel>>> {
    return GetCurrentBehaviorBIPInfos(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetCurrentBehaviorBIPInfos$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetCurrentBehaviorBIPInfos(params?: GetCurrentBehaviorBIPInfos$Params, context?: HttpContext): Observable<Array<BehaviorBipInfoModel>> {
    return this.GetCurrentBehaviorBIPInfos$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BehaviorBipInfoModel>>): Array<BehaviorBipInfoModel> => r.body)
    );
  }

  /** Path part for operation `apiStaffGetNewBehaviorBipInfosGet()` */
  static readonly ApiStaffGetNewBehaviorBipInfosGetPath = '/api/Staff/GetNewBehaviorBIPInfos';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetNewBehaviorBIPInfos()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetNewBehaviorBIPInfos$Response(params?: GetNewBehaviorBIPInfos$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BehaviorBipInfoModel>>> {
    return GetNewBehaviorBIPInfos(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetNewBehaviorBIPInfos$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetNewBehaviorBIPInfos(params?: GetNewBehaviorBIPInfos$Params, context?: HttpContext): Observable<Array<BehaviorBipInfoModel>> {
    return this.GetNewBehaviorBIPInfos$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BehaviorBipInfoModel>>): Array<BehaviorBipInfoModel> => r.body)
    );
  }

  /** Path part for operation `apiStaffGetCurrentBehaviorBipInfoByBehaviorGet()` */
  static readonly ApiStaffGetCurrentBehaviorBipInfoByBehaviorGetPath = '/api/Staff/GetCurrentBehaviorBIPInfoByBehavior';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetCurrentBehaviorBIPInfoByBehavior()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetCurrentBehaviorBIPInfoByBehavior$Response(params?: GetCurrentBehaviorBIPInfoByBehavior$Params, context?: HttpContext): Observable<StrictHttpResponse<BehaviorBipInfoModel>> {
    return GetCurrentBehaviorBIPInfoByBehavior(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetCurrentBehaviorBIPInfoByBehavior$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetCurrentBehaviorBIPInfoByBehavior(params?: GetCurrentBehaviorBIPInfoByBehavior$Params, context?: HttpContext): Observable<BehaviorBipInfoModel> {
    return this.GetCurrentBehaviorBIPInfoByBehavior$Response(params, context).pipe(
      map((r: StrictHttpResponse<BehaviorBipInfoModel>): BehaviorBipInfoModel => r.body)
    );
  }

  /** Path part for operation `apiStaffGetNewBehaviorBipInfoByBehaviorGet()` */
  static readonly ApiStaffGetNewBehaviorBipInfoByBehaviorGetPath = '/api/Staff/GetNewBehaviorBIPInfoByBehavior';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetNewBehaviorBIPInfoByBehavior()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetNewBehaviorBIPInfoByBehavior$Response(params?: GetNewBehaviorBIPInfoByBehavior$Params, context?: HttpContext): Observable<StrictHttpResponse<BehaviorBipInfoModel>> {
    return GetNewBehaviorBIPInfoByBehavior(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetNewBehaviorBIPInfoByBehavior$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetNewBehaviorBIPInfoByBehavior(params?: GetNewBehaviorBIPInfoByBehavior$Params, context?: HttpContext): Observable<BehaviorBipInfoModel> {
    return this.GetNewBehaviorBIPInfoByBehavior$Response(params, context).pipe(
      map((r: StrictHttpResponse<BehaviorBipInfoModel>): BehaviorBipInfoModel => r.body)
    );
  }

  /** Path part for operation `apiStaffGetBehaviorBipInfoScreenDataGet()` */
  static readonly ApiStaffGetBehaviorBipInfoScreenDataGetPath = '/api/Staff/GetBehaviorBipInfoScreenData';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetBehaviorBipInfoScreenData()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetBehaviorBipInfoScreenData$Response(params?: GetBehaviorBipInfoScreenData$Params, context?: HttpContext): Observable<StrictHttpResponse<BehaviorBipInfoScreenDataModel>> {
    return GetBehaviorBipInfoScreenData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetBehaviorBipInfoScreenData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetBehaviorBipInfoScreenData(params?: GetBehaviorBipInfoScreenData$Params, context?: HttpContext): Observable<BehaviorBipInfoScreenDataModel> {
    return this.GetBehaviorBipInfoScreenData$Response(params, context).pipe(
      map((r: StrictHttpResponse<BehaviorBipInfoScreenDataModel>): BehaviorBipInfoScreenDataModel => r.body)
    );
  }

  /** Path part for operation `apiStaffGetAntecedentStrategyTemplatesGet()` */
  static readonly ApiStaffGetAntecedentStrategyTemplatesGetPath = '/api/Staff/GetAntecedentStrategyTemplates';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetAntecedentStrategyTemplates()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetAntecedentStrategyTemplates$Response(params?: GetAntecedentStrategyTemplates$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<NameDescriptionModel>>> {
    return GetAntecedentStrategyTemplates(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetAntecedentStrategyTemplates$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetAntecedentStrategyTemplates(params?: GetAntecedentStrategyTemplates$Params, context?: HttpContext): Observable<Array<NameDescriptionModel>> {
    return this.GetAntecedentStrategyTemplates$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<NameDescriptionModel>>): Array<NameDescriptionModel> => r.body)
    );
  }

  /** Path part for operation `apiStaffGetConsequenceStrategyTemplatesGet()` */
  static readonly ApiStaffGetConsequenceStrategyTemplatesGetPath = '/api/Staff/GetConsequenceStrategyTemplates';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetConsequenceStrategyTemplates()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetConsequenceStrategyTemplates$Response(params?: GetConsequenceStrategyTemplates$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<NameDescriptionModel>>> {
    return GetConsequenceStrategyTemplates(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetConsequenceStrategyTemplates$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetConsequenceStrategyTemplates(params?: GetConsequenceStrategyTemplates$Params, context?: HttpContext): Observable<Array<NameDescriptionModel>> {
    return this.GetConsequenceStrategyTemplates$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<NameDescriptionModel>>): Array<NameDescriptionModel> => r.body)
    );
  }

  /** Path part for operation `apiStaffGetReplacementStrategyTemplatesGet()` */
  static readonly ApiStaffGetReplacementStrategyTemplatesGetPath = '/api/Staff/GetReplacementStrategyTemplates';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetReplacementStrategyTemplates()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetReplacementStrategyTemplates$Response(params?: GetReplacementStrategyTemplates$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<NameDescriptionModel>>> {
    return GetReplacementStrategyTemplates(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetReplacementStrategyTemplates$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetReplacementStrategyTemplates(params?: GetReplacementStrategyTemplates$Params, context?: HttpContext): Observable<Array<NameDescriptionModel>> {
    return this.GetReplacementStrategyTemplates$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<NameDescriptionModel>>): Array<NameDescriptionModel> => r.body)
    );
  }

  /** Path part for operation `apiStaffSaveBehaviorBipInfoPost()` */
  static readonly ApiStaffSaveBehaviorBipInfoPostPath = '/api/Staff/SaveBehaviorBIPInfo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveBehaviorBIPInfo()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveBehaviorBIPInfo$Response(params?: SaveBehaviorBIPInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<BehaviorBipInfoModel>> {
    return SaveBehaviorBIPInfo(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveBehaviorBIPInfo$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveBehaviorBIPInfo(params?: SaveBehaviorBIPInfo$Params, context?: HttpContext): Observable<BehaviorBipInfoModel> {
    return this.SaveBehaviorBIPInfo$Response(params, context).pipe(
      map((r: StrictHttpResponse<BehaviorBipInfoModel>): BehaviorBipInfoModel => r.body)
    );
  }

  /** Path part for operation `apiStaffGetCurrentPatientBipInfoGet()` */
  static readonly ApiStaffGetCurrentPatientBipInfoGetPath = '/api/Staff/GetCurrentPatientBIPInfo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetCurrentPatientBIPInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetCurrentPatientBIPInfo$Response(params?: GetCurrentPatientBIPInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientBipInfoModel>> {
    return GetCurrentPatientBIPInfo(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetCurrentPatientBIPInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetCurrentPatientBIPInfo(params?: GetCurrentPatientBIPInfo$Params, context?: HttpContext): Observable<PatientBipInfoModel> {
    return this.GetCurrentPatientBIPInfo$Response(params, context).pipe(
      map((r: StrictHttpResponse<PatientBipInfoModel>): PatientBipInfoModel => r.body)
    );
  }

  /** Path part for operation `apiStaffDeleteAntecedentFromBehaviorBipInfoPost()` */
  static readonly ApiStaffDeleteAntecedentFromBehaviorBipInfoPostPath = '/api/Staff/DeleteAntecedentFromBehaviorBIPInfo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `DeleteAntecedentFromBehaviorBIPInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  DeleteAntecedentFromBehaviorBIPInfo$Response(params?: DeleteAntecedentFromBehaviorBIPInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return DeleteAntecedentFromBehaviorBIPInfo(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `DeleteAntecedentFromBehaviorBIPInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  DeleteAntecedentFromBehaviorBIPInfo(params?: DeleteAntecedentFromBehaviorBIPInfo$Params, context?: HttpContext): Observable<void> {
    return this.DeleteAntecedentFromBehaviorBIPInfo$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiStaffDeleteConsequenceFromBehaviorBipInfoPost()` */
  static readonly ApiStaffDeleteConsequenceFromBehaviorBipInfoPostPath = '/api/Staff/DeleteConsequenceFromBehaviorBIPInfo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `DeleteConsequenceFromBehaviorBIPInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  DeleteConsequenceFromBehaviorBIPInfo$Response(params?: DeleteConsequenceFromBehaviorBIPInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return DeleteConsequenceFromBehaviorBIPInfo(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `DeleteConsequenceFromBehaviorBIPInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  DeleteConsequenceFromBehaviorBIPInfo(params?: DeleteConsequenceFromBehaviorBIPInfo$Params, context?: HttpContext): Observable<void> {
    return this.DeleteConsequenceFromBehaviorBIPInfo$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiStaffDeleteReplacementFromBehaviorBipInfoPost()` */
  static readonly ApiStaffDeleteReplacementFromBehaviorBipInfoPostPath = '/api/Staff/DeleteReplacementFromBehaviorBIPInfo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `DeleteReplacementFromBehaviorBIPInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  DeleteReplacementFromBehaviorBIPInfo$Response(params?: DeleteReplacementFromBehaviorBIPInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return DeleteReplacementFromBehaviorBIPInfo(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `DeleteReplacementFromBehaviorBIPInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  DeleteReplacementFromBehaviorBIPInfo(params?: DeleteReplacementFromBehaviorBIPInfo$Params, context?: HttpContext): Observable<void> {
    return this.DeleteReplacementFromBehaviorBIPInfo$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiStaffSavePatientBipInfoPost()` */
  static readonly ApiStaffSavePatientBipInfoPostPath = '/api/Staff/SavePatientBIPInfo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SavePatientBIPInfo()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePatientBIPInfo$Response(params?: SavePatientBIPInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientBipInfoModel>> {
    return SavePatientBIPInfo(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SavePatientBIPInfo$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePatientBIPInfo(params?: SavePatientBIPInfo$Params, context?: HttpContext): Observable<PatientBipInfoModel> {
    return this.SavePatientBIPInfo$Response(params, context).pipe(
      map((r: StrictHttpResponse<PatientBipInfoModel>): PatientBipInfoModel => r.body)
    );
  }

  /** Path part for operation `apiStaffGetNewPatientBipInfoGet()` */
  static readonly ApiStaffGetNewPatientBipInfoGetPath = '/api/Staff/GetNewPatientBIPInfo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetNewPatientBIPInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetNewPatientBIPInfo$Response(params?: GetNewPatientBIPInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientBipInfoModel>> {
    return GetNewPatientBIPInfo(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetNewPatientBIPInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetNewPatientBIPInfo(params?: GetNewPatientBIPInfo$Params, context?: HttpContext): Observable<PatientBipInfoModel> {
    return this.GetNewPatientBIPInfo$Response(params, context).pipe(
      map((r: StrictHttpResponse<PatientBipInfoModel>): PatientBipInfoModel => r.body)
    );
  }

  /** Path part for operation `apiStaffGetSessionProgressNotesGet()` */
  static readonly ApiStaffGetSessionProgressNotesGetPath = '/api/Staff/GetSessionProgressNotes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetSessionProgressNotes()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetSessionProgressNotes$Response(params?: GetSessionProgressNotes$Params, context?: HttpContext): Observable<StrictHttpResponse<SessionProgressNoteModel>> {
    return GetSessionProgressNotes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetSessionProgressNotes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetSessionProgressNotes(params?: GetSessionProgressNotes$Params, context?: HttpContext): Observable<SessionProgressNoteModel> {
    return this.GetSessionProgressNotes$Response(params, context).pipe(
      map((r: StrictHttpResponse<SessionProgressNoteModel>): SessionProgressNoteModel => r.body)
    );
  }

  /** Path part for operation `apiStaffSaveSessionProgressNotesPost()` */
  static readonly ApiStaffSaveSessionProgressNotesPostPath = '/api/Staff/SaveSessionProgressNotes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveSessionProgressNotes()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveSessionProgressNotes$Response(params?: SaveSessionProgressNotes$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return SaveSessionProgressNotes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveSessionProgressNotes$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveSessionProgressNotes(params?: SaveSessionProgressNotes$Params, context?: HttpContext): Observable<void> {
    return this.SaveSessionProgressNotes$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiStaffUploadGuardianSignaturePost()` */
  static readonly ApiStaffUploadGuardianSignaturePostPath = '/api/Staff/UploadGuardianSignature';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `UploadGuardianSignature()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  UploadGuardianSignature$Response(params?: UploadGuardianSignature$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return UploadGuardianSignature(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `UploadGuardianSignature$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  UploadGuardianSignature(params?: UploadGuardianSignature$Params, context?: HttpContext): Observable<void> {
    return this.UploadGuardianSignature$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiStaffDownloadGuardianSignatureGet()` */
  static readonly ApiStaffDownloadGuardianSignatureGetPath = '/api/Staff/DownloadGuardianSignature';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `DownloadGuardianSignature()` instead.
   *
   * This method doesn't expect any request body.
   */
  DownloadGuardianSignature$Response(params?: DownloadGuardianSignature$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return DownloadGuardianSignature(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `DownloadGuardianSignature$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  DownloadGuardianSignature(params?: DownloadGuardianSignature$Params, context?: HttpContext): Observable<void> {
    return this.DownloadGuardianSignature$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiStaffUploadStaffHandoffSignaturePost()` */
  static readonly ApiStaffUploadStaffHandoffSignaturePostPath = '/api/Staff/UploadStaffHandoffSignature';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `UploadStaffHandoffSignature()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  UploadStaffHandoffSignature$Response(params?: UploadStaffHandoffSignature$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return UploadStaffHandoffSignature(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `UploadStaffHandoffSignature$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  UploadStaffHandoffSignature(params?: UploadStaffHandoffSignature$Params, context?: HttpContext): Observable<void> {
    return this.UploadStaffHandoffSignature$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiStaffDownloadStaffHandoffSignatureGet()` */
  static readonly ApiStaffDownloadStaffHandoffSignatureGetPath = '/api/Staff/DownloadStaffHandoffSignature';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `DownloadStaffHandoffSignature()` instead.
   *
   * This method doesn't expect any request body.
   */
  DownloadStaffHandoffSignature$Response(params?: DownloadStaffHandoffSignature$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return DownloadStaffHandoffSignature(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `DownloadStaffHandoffSignature$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  DownloadStaffHandoffSignature(params?: DownloadStaffHandoffSignature$Params, context?: HttpContext): Observable<void> {
    return this.DownloadStaffHandoffSignature$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiStaffGetMyServicesGet()` */
  static readonly ApiStaffGetMyServicesGetPath = '/api/Staff/GetMyServices';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetMyServices()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetMyServices$Response(params?: GetMyServices$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientServiceSparkModel>>> {
    return GetMyServices(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetMyServices$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetMyServices(params?: GetMyServices$Params, context?: HttpContext): Observable<Array<PatientServiceSparkModel>> {
    return this.GetMyServices$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PatientServiceSparkModel>>): Array<PatientServiceSparkModel> => r.body)
    );
  }

  /** Path part for operation `apiStaffGetPatientServicesGet()` */
  static readonly ApiStaffGetPatientServicesGetPath = '/api/Staff/GetPatientServices';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPatientServices()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientServices$Response(params?: GetPatientServices$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ServiceSparkModel>>> {
    return GetPatientServices(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPatientServices$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientServices(params?: GetPatientServices$Params, context?: HttpContext): Observable<Array<ServiceSparkModel>> {
    return this.GetPatientServices$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ServiceSparkModel>>): Array<ServiceSparkModel> => r.body)
    );
  }

  /** Path part for operation `apiStaffGetBehaviorFunctionsGet()` */
  static readonly ApiStaffGetBehaviorFunctionsGetPath = '/api/Staff/GetBehaviorFunctions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetBehaviorFunctions()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetBehaviorFunctions$Response(params?: GetBehaviorFunctions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BehaviorFunctionModel>>> {
    return GetBehaviorFunctions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetBehaviorFunctions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetBehaviorFunctions(params?: GetBehaviorFunctions$Params, context?: HttpContext): Observable<Array<BehaviorFunctionModel>> {
    return this.GetBehaviorFunctions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BehaviorFunctionModel>>): Array<BehaviorFunctionModel> => r.body)
    );
  }

  /** Path part for operation `apiStaffGetPatientBiPsGet()` */
  static readonly ApiStaffGetPatientBiPsGetPath = '/api/Staff/GetPatientBIPs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetPatientBIPs()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientBIPs$Response(params?: GetPatientBIPs$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BipModel>>> {
    return GetPatientBIPs(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetPatientBIPs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetPatientBIPs(params?: GetPatientBIPs$Params, context?: HttpContext): Observable<Array<BipModel>> {
    return this.GetPatientBIPs$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BipModel>>): Array<BipModel> => r.body)
    );
  }

  /** Path part for operation `apiStaffGetBipPdfGet()` */
  static readonly ApiStaffGetBipPdfGetPath = '/api/Staff/GetBipPdf';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetBipPdf()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetBipPdf$Response(params?: GetBipPdf$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return GetBipPdf(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetBipPdf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetBipPdf(params?: GetBipPdf$Params, context?: HttpContext): Observable<Blob> {
    return this.GetBipPdf$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiStaffFinishAndSignBipPost()` */
  static readonly ApiStaffFinishAndSignBipPostPath = '/api/Staff/FinishAndSignBIP';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `FinishAndSignBIP()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  FinishAndSignBIP$Response(params?: FinishAndSignBIP$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return FinishAndSignBIP(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `FinishAndSignBIP$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  FinishAndSignBIP(params?: FinishAndSignBIP$Params, context?: HttpContext): Observable<void> {
    return this.FinishAndSignBIP$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiStaffSaveBehaviorOrderPost()` */
  static readonly ApiStaffSaveBehaviorOrderPostPath = '/api/Staff/SaveBehaviorOrder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveBehaviorOrder()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveBehaviorOrder$Response(params?: SaveBehaviorOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return SaveBehaviorOrder(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveBehaviorOrder$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveBehaviorOrder(params?: SaveBehaviorOrder$Params, context?: HttpContext): Observable<void> {
    return this.SaveBehaviorOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiStaffMarkMultiplePatientBehaviorsAsDeletedPost()` */
  static readonly ApiStaffMarkMultiplePatientBehaviorsAsDeletedPostPath = '/api/Staff/MarkMultiplePatientBehaviorsAsDeleted';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `MarkMultiplePatientBehaviorsAsDeleted()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  MarkMultiplePatientBehaviorsAsDeleted$Response(params?: MarkMultiplePatientBehaviorsAsDeleted$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return MarkMultiplePatientBehaviorsAsDeleted(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `MarkMultiplePatientBehaviorsAsDeleted$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  MarkMultiplePatientBehaviorsAsDeleted(params?: MarkMultiplePatientBehaviorsAsDeleted$Params, context?: HttpContext): Observable<void> {
    return this.MarkMultiplePatientBehaviorsAsDeleted$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
